import apiHandler from "../core/apiHandler";

const inventoryTransferApi = apiHandler("inventory/transfers");

export default inventoryTransferApi;
